import type { Step } from 'react-joyride';
import type { NavigateFunction } from 'react-router-dom';
import type { TFunction } from 'i18next';

export const TUTORIAL_FLAG = 'tutorial_completed_v2';

interface RawStep {
  path: string;
  target: string;
  key: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
}

const RAW: RawStep[] = [
  // ---- Home: wallet card area
  { path: '/home', target: '[data-tour="wallet-card"]',
    placement: 'bottom',
    key: 'wallet' },
  { path: '/home', target: '[data-tour="wallet-card-withdraw"]',
    placement: 'left',
    key: 'walletWithdraw' },
  { path: '/home', target: '[data-tour="wallet-card-topup"]',
    placement: 'left',
    key: 'walletTopup' },

  // ---- Home: 6 quick actions
  { path: '/home', target: '[data-tour="qa-wallet-topup"]',
    placement: 'bottom',
    key: 'quickWallet' },
  { path: '/home', target: '[data-tour="qa-game-topup"]',
    placement: 'bottom',
    key: 'quickGame' },
  { path: '/home', target: '[data-tour="qa-withdraw"]',
    placement: 'top',
    key: 'quickWithdraw' },
  { path: '/home', target: '[data-tour="qa-support"]',
    placement: 'top',
    key: 'quickSupport' },
  { path: '/home', target: '[data-tour="qa-promo"]',
    placement: 'top',
    key: 'quickPromo' },
  { path: '/home', target: '[data-tour="qa-referral"]',
    placement: 'top',
    key: 'quickReferral' },

  // ---- Bottom nav (single overview)
  { path: '/home', target: '[data-tour="bottom-nav"]',
    placement: 'top',
    key: 'navigation' },

  // ---- Cross-page walkthrough
  { path: '/games', target: '[data-tour="games-header"]',
    placement: 'bottom',
    key: 'games' },
  { path: '/games', target: '[data-tour="game-card-first"]',
    placement: 'bottom',
    key: 'gameCard' },
  { path: '/topup', target: '[data-tour="topup-form"]',
    placement: 'bottom',
    key: 'topup' },
  { path: '/withdraw', target: '[data-tour="withdraw-choice"]',
    placement: 'top',
    key: 'withdraw' },
  { path: '/profile', target: '[data-tour="profile-history"]',
    placement: 'bottom',
    key: 'history' },
  { path: '/profile', target: '[data-tour="profile-howitworks"]',
    placement: 'bottom',
    key: 'guide' },
  { path: '/profile', target: '[data-tour="profile-replay"]',
    placement: 'top',
    key: 'complete' },
];

const baseStep = {
  buttons: ['back', 'primary', 'skip'] as ('back' | 'primary' | 'skip' | 'close')[],
  skipBeacon: true,
};

export function buildSteps(navigate: NavigateFunction, getPath: () => string, t: TFunction): Step[] {
  const wait = (ms: number) => new Promise<void>(r => setTimeout(r, ms));
  return RAW.map(({ path, target, key, placement }) => ({
    ...baseStep,
    target,
    title: t(`home:tutorial.steps.${key}.title`),
    content: t(`home:tutorial.steps.${key}.body`),
    placement,
    before: async () => {
      if (getPath() !== path) {
        navigate(path);
        // Allow the route to mount and the target element to render.
        await wait(500);
      }
    },
  }));
}

export const TUTORIAL_STEP_COUNT = RAW.length;
